import React from "react";
import { useDispatch } from "react-redux";

import { Notification } from "@/types/Notification";
import { removeNotification } from "@/redux/reducer/notificationSlice";
import NotificationItem from "./NotificationItem";

interface NotificationPanelProps {
  notifications: Notification[];
}


const NotificationPanel: React.FC<NotificationPanelProps> = ({ notifications }) => {
  const dispatch = useDispatch();

  const handleRemoveNotification = (id: number) => {
    dispatch(removeNotification({ id }));
  };

  return (
    <div className="fixed top-24 right-3 space-y-2 z-9999">
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onRemove={handleRemoveNotification}
        />
      ))}
    </div>
  );
};

export default NotificationPanel;